export enum TagTheme {
  DEFAULT = 'default',
  ACTIVE = 'active',
  WHITE = 'white',
  SUSTAINABILITY = 'sustainability',
  SUCCESS = 'success',
  WARNING = 'warning',
  ALERT = 'alert',
  POPULAR = 'popular',
  BLACK_FRIDAY = 'black-friday',
}

export enum TagRoundingStyle {
  DEFAULT = 'default',
  CHIP = 'chip',
}
